/**
 * video-url.ts – Helper für die Auswahl der besten verfügbaren Video-URL.
 *
 * Priorität: processed_video_url → video_url → null
 *
 * Rückwärtskompatibel: funktioniert mit alten Profilen, die nur video_url haben.
 */

export interface VideoUrlProfile {
  video_url?:          string | null;
  processed_video_url?: string | null;
  thumbnail_url?:      string | null;
}

const DEFAULT_THUMBNAIL = '/images/default-video-thumbnail.jpg';

/**
 * Gibt die beste verfügbare Video-URL zurück.
 *
 * - Hat ein Profil eine optimierte Version → diese wird bevorzugt
 * - Andernfalls Fallback auf das Original (video_url)
 * - Altprofile ohne processed_video_url funktionieren unverändert weiter
 */
export function getBestVideoUrl(profile: VideoUrlProfile): string | null {
  return profile.processed_video_url ?? profile.video_url ?? null;
}

/**
 * Gibt die Thumbnail-URL zurück, mit Fallback auf das Standard-Bild.
 */
export function getBestThumbnailUrl(
  profile: VideoUrlProfile,
  fallback: string = DEFAULT_THUMBNAIL,
): string {
  return profile.thumbnail_url ?? fallback;
}

/**
 * Gibt true zurück wenn für dieses Profil eine optimierte Version verfügbar ist.
 */
export function hasProcessedVideo(profile: VideoUrlProfile): boolean {
  return !!profile.processed_video_url;
}
